import React from 'react';
import { CalendarDays, CreditCard, ShoppingBag, Receipt, ChevronLeft } from 'lucide-react';

interface PerkDetailProps {
    imageUrl: string;
    logoUrl: string;
    title: string;
    label: string;
    status: 'Activated' | 'Redeem';
    description: string;
    termsUrl?: string;
    dateRange?: string;
    howTo?: {
        icon: React.ReactNode;
        text: string;
    }[];

    handleBack: () => void
}

const PerkDetail: React.FC<PerkDetailProps> = ({
    imageUrl,
    logoUrl,
    title,
    label,
    status,
    description,
    dateRange,
    termsUrl,
    howTo,
    handleBack
}) => {
    return (
        <div className="m-5 font-medium">
            <div className="subpage-header-container">
                <button onClick={handleBack}>
                    <ChevronLeft />
                </button>
                <h2>{title}</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Left Side */}
                <div>
                    <div className="relative">
                        <img src={imageUrl} alt={title} className="w-full h-64 object-cover rounded-lg" />
                        <div className="absolute top-4 left-4 bg-white text-sm font-semibold px-2 py-1 rounded shadow">
                            {label}
                        </div>
                        <div className="absolute bottom-4 left-4 w-14 h-14 bg-white rounded-full shadow flex items-center justify-center">
                            <img src={logoUrl} alt="Logo" className="w-full" />
                        </div>
                    </div>
                    {dateRange && (
                        <div className="flex items-center gap-2 mt-4">
                            <CalendarDays className="w-4 h-4" />
                            <span>{dateRange}</span>
                        </div>
                    )}
                    <p className="mt-3 text-lg text-gray-500">{description}</p>
                    {termsUrl && (
                        <a href={termsUrl} className="text-sm font-normal text-gray-500 underline mt-3 block">
                            Terms and conditions
                        </a>
                    )}
                </div>

                {/* Right Side */}
                <div className="bg-gray-50 rounded-lg p-5 border">
                    <h2 className="text-base font-semibold mb-1">{title}</h2>
                    <p className="text-gray-500 mb-4">{label}</p>

                    <div
                        className={`inline-block px-2 py-1 rounded mb-4 ${status === 'Activated'
                            ? 'bg-green-100 text-green-600'
                            : 'bg-blue-100 text-blue-600'
                            }`}
                    >
                        {status}
                    </div>

                    <p className="font-medium mb-3">How to get 3 Months free</p>
                    <ul className="space-y-5">
                        {howTo && howTo.map((item, idx) => (
                            <li key={idx} className="flex items-center gap-3">
                                <div className="w-6 h-6 flex items-center justify-center bg-gray-100 rounded-full">
                                    {item.icon}
                                </div>
                                <span>{item.text}</span>
                            </li>
                        ))}
                    </ul>
                    <p className="font-normal text-gray-500 mt-4">
                        Does not combine with other partner promotions.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PerkDetail;
